var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdditionalFieldsBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6563 3.89777C8.7408 3.89777 7.18799 5.44392 7.18799 7.3512C7.18799 9.25847 8.7408 10.8046 10.6563 10.8046H39.9978C41.9133 10.8046 43.4661 9.25847 43.4661 7.3512C43.4661 5.44392 41.9133 3.89777 39.9978 3.89777H10.6563ZM3.27344 7.3512C3.27344 3.29124 6.57885 0 10.6563 0H39.9978C44.0752 0 47.3806 3.29124 47.3806 7.3512C47.3806 11.4111 44.0752 14.7024 39.9978 14.7024H10.6563C6.57885 14.7024 3.27344 11.4111 3.27344 7.3512Z",
    fill: "#244277"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6563 21.5423C8.7408 21.5423 7.18799 23.0885 7.18799 24.9957C7.18799 26.903 8.74079 28.4492 10.6563 28.4492H39.9978C41.9133 28.4492 43.4661 26.903 43.4661 24.9957C43.4661 23.0885 41.9133 21.5423 39.9978 21.5423H10.6563ZM3.27344 24.9957C3.27344 20.9358 6.57885 17.6445 10.6563 17.6445H39.9978C44.0752 17.6445 47.3806 20.9358 47.3806 24.9957C47.3806 29.0557 44.0752 32.3469 39.9978 32.3469H10.6563C6.57885 32.3469 3.27344 29.0557 3.27344 24.9957Z",
    fill: "#244277"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6563 37.7142C8.74079 37.7142 7.18799 39.2603 7.18799 41.1676C7.18799 43.0749 8.7408 44.621 10.6563 44.621H39.9978C41.9133 44.621 43.4661 43.0749 43.4661 41.1676C43.4661 39.2603 41.9133 37.7142 39.9978 37.7142H10.6563ZM3.27344 41.1676C3.27344 37.1076 6.57885 33.8164 10.6563 33.8164H39.9978C44.0752 33.8164 47.3806 37.1076 47.3806 41.1676C47.3806 45.2276 44.0752 48.5188 39.9978 48.5188H10.6563C6.57885 48.5188 3.27344 45.2276 3.27344 41.1676Z",
    fill: "#244277"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalFieldsBlue);
export default __webpack_public_path__ + "static/media/additional_fields_blue.65c3fde80068936ede40b561ddd66c2a.svg";
export { ForwardRef as ReactComponent };